export default function (instance, task) {
  const el = document.createElement('div');

  el.setAttribute(instance.config.task_attribute, task.id);

  el.className = instance.templates.grid_row_class(task.start_date, task.end_date, task);
  el.style.height = `${instance.config.row_height}px`;
  el.style.lineHeight = `${instance.config.row_height}px`;
  el.style.position = 'absolute';
  el.style.left = '0px';
  el.style.top = `${instance.getTaskTop(task.id)}px`;

  return el;
}
